import classNames from "classnames";
import React, { FunctionComponent, ReactElement, useCallback, useEffect, useRef } from "react";
import Ripple from "@Components/atoms/cart/RippleEffect";
import { Country } from "@Types/cart";
import "./style.scss";

interface Props {
  country: Country;
  onMouseUp: (country: Country) => void;
  selected: boolean;
}

const CartCountriesListItem: FunctionComponent<Props> = ({
  country,
  onMouseUp,
  selected,
}): ReactElement => {
  const liRef = useRef<HTMLLIElement>(null);

  useEffect(() => {
    if (selected && liRef.current) {
      liRef.current.scrollIntoView({
        block: "center",
      });
    }
  }, [liRef, selected]);

  const handleMouseUp = useCallback(() => {
    onMouseUp(country);
  }, [onMouseUp, country]);

  return (
    <li
      className={classNames("CartCountriesListItem", {
        "CartCountriesListItem--selected": selected,
      })}
      ref={liRef}
    >
      <Ripple color={selected ? "blue" : "grey"} onMouseUp={handleMouseUp}>
        <span className="CartCountriesListItem-content">
          <span
            className={classNames(
              "CartCountriesListItem-flag",
              `CartCountriesListItem-flag--${country.tag.toLowerCase()}`
            )}
          />
          <span className="CartCountriesListItem-name">{country.name}</span>
        </span>
      </Ripple>
    </li>
  );
};

export default CartCountriesListItem;
